<template id="dlgMapRenderThreeJsTmpl" >
  <v-dialog v-model="dlgMapRenderThreeJsIsOpen" fullscreen hide-overlay transition="dialog-bottom-transition" :persistent="true">
      <v-card>

        <v-toolbar color="primary" dark absolute left style="width: 100%">
            <v-btn icon dark v-on:click="closeMapRenderThreeJs()"><v-icon>close</v-icon></v-btn>
            <v-toolbar-title v-if="mapDetailObj != null">
                    {{mapDetailObj.map_name}}
                    
                    <v-btn 
                      class="mr-2" 
                      color="secondary" 
                      fab small bottom right absolute 
                      v-if="isEmptyObj(mapDetailObj) == false && isEmptyString(mapDetailObj.map_link) == false"
                      v-on:click="openMapLink(mapDetailObj.map_link)" >
                          <v-icon style="color:#000;" >list_alt</v-icon>
                    </v-btn> 
                    
               
            </v-toolbar-title>
            <v-toolbar-title v-else>{{$t('err.mapSelectedNotValid')}}</v-toolbar-title>
        </v-toolbar>
        
        <div v-if="isEmptyObj(mapDetailObj) == false && dlgMapRenderThreeJsIsOpen == true">
          <ct-map-rendering-threejs ref="renderthreejsInner" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapDetailObj" :printMouse="printMouse" ></ct-map-rendering-threejs>
        </div>

    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';
import ctRenderThreejs from "@/components/commons/ctRenderThreejs.vue";

export default {
    i18n,
    data: () => ({
      dlgMapRenderThreeJsIsOpen: false,
    }),
    props: ['orgid', 'siteid', 'mapDetailObj', 'printMouse'],
    components: {
      'ct-map-rendering-threejs': ctRenderThreejs
    }, 
    methods: {
      openMapRenderThreeJs() 
      {
         this.dlgMapRenderThreeJsIsOpen = true;
         events.$emit(constants.EVENT_DIALOG_RENDER_3D_OPEN);
      },
      closeMapRenderThreeJs() 
      {
        this.dlgMapRenderThreeJsIsOpen = false;
        //this.$refs.renderthreejsInner.removeListeners();
        events.$emit(constants.EVENT_DIALOG_RENDER_3D_CLOSE);
      },
      openMapLink(link)
      {
        window.open(link,'_blank');
      },
    }
};
</script>